import { RoleTypeEnum } from 'src/enums/roleTypeEnum';

export class SelectRole {
    constructor(value: RoleTypeEnum, label: string) {
        this.value = value;
        this.label = label;
    }
    value: RoleTypeEnum;
    label: string;
}
